import { bindActionCreators } from 'redux';
import { setCurrentPathName } from '../../redux/app/actions';

export default (dispatch) => ({
  ...bindActionCreators(
    {
      setCurrentPathName,
    },
    dispatch,
  ),
});
